export default abstract class Answer {
    abstract getResponse(): any;
    abstract hasResponse(): boolean;
    abstract toObject(): {};
}
